import { ListenableSubscribable } from '@benzinga/subscribable';
import { GptSearchEvent } from './manager';
import { GptSearchRestful } from './restful';
import { Session } from '@benzinga/session';
import { GptResponseData, GptConfigParameters } from './entity';
import { SafePromise } from '@benzinga/safe-await';

export class GptSearchRequest extends ListenableSubscribable<GptSearchEvent> {
  private restful: GptSearchRestful;

  constructor(session: Session) {
    super();
    this.restful = new GptSearchRestful(session);
  }

  public getScannerConfig = async <T extends object>(config: GptConfigParameters<T>): SafePromise<T> => {
    const response = await this.restful.getScannerConfig<T>(config);
    if (response.err) {
      this.dispatch({
        error: response.err,
        type: 'gpt-search:error',
      });
      return { err: response.err };
    }
    this.dispatch({
      data: [response.ok] as GptResponseData<T>[],
      type: 'gpt-search:update',
    });
    return { ok: response.ok };
  };

  public getNewsFeedConfig = async <T extends object>(config: GptConfigParameters<T>): SafePromise<T> => {
    const response = await this.restful.getNewsFeedConfig<T>(config);
    if (response.err) {
      this.dispatch({
        error: response.err,
        type: 'gpt-search:error',
      });
      return { err: response.err };
    }
    this.dispatch({
      data: [response.ok] as GptResponseData<T>[],
      type: 'gpt-search:update',
    });
    return { ok: response.ok };
  };
}
